// @ts-nocheck
/* Port of ReleaseFloatingDock.js (97L). BYTE-IDENTICAL. */
import React, { useEffect, useState } from 'react';
import {
  FiSearch,
  FiPlus,
  FiRepeat,
  FiArrowUp,
  FiX,
  FiGrid,
} from 'react-icons/fi';

const DOCK_KEY = 'rc_dock_open';

const ReleaseFloatingDock = ({
  canManage,
  onSearch,
  onCreate,
  onCompare,
  onScrollTop,
}: any) => {
  const [open, setOpen] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(DOCK_KEY) !== '0';
    } catch {
      return true;
    }
  });

  useEffect(() => {
    try {
      sessionStorage.setItem(DOCK_KEY, open ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [open]);

  useEffect(() => {
    const onKey = (e: any) => {
      if (e.key === 'Escape' && open) setOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const run = (fn: any) => () => {
    if (typeof fn === 'function') fn();
  };

  const items = [
    {
      key: 'search',
      icon: <FiSearch />,
      label: 'Search',
      onClick: onSearch,
      plain: false,
    },
    canManage && {
      key: 'create',
      icon: <FiPlus />,
      label: 'New release',
      onClick: onCreate,
      plain: false,
    },
    {
      key: 'compare',
      icon: <FiRepeat />,
      label: 'Compare',
      onClick: onCompare,
      plain: true,
    },
    {
      key: 'top',
      icon: <FiArrowUp />,
      label: 'Back to top',
      onClick: onScrollTop,
      plain: true,
    },
  ].filter(Boolean);

  return (
    <div className={`rc-dock ${open ? 'rc-dock--open' : ''}`}>
      {open && (
        <div
          className="rc-dock__panel"
          role="menu"
          aria-label="Release Notes quick actions"
        >
          {items.map((it: any) => (
            <button
              key={it.key}
              type="button"
              role="menuitem"
              className={`rc-dock__item ${
                it.plain ? 'rc-dock__item--plain' : ''
              }`}
              onClick={run(it.onClick)}
            >
              <span className="rc-dock__ico" aria-hidden="true">
                {it.icon}
              </span>
              <span>{it.label}</span>
            </button>
          ))}
        </div>
      )}

      <button
        type="button"
        className="rc-dock__fab"
        aria-expanded={open}
        aria-label={open ? 'Minimize quick actions' : 'Open quick actions'}
        title={open ? 'Minimize' : 'Quick actions'}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="rc-dock__fab-ico" aria-hidden="true">
          {open ? <FiX size={22} /> : <FiGrid size={22} />}
        </span>
      </button>
    </div>
  );
};

export default ReleaseFloatingDock;
